<template>
  <nav class="navbar navbar-toggleable-sm navbar-light bg-faded">
    <button class="navbar-toggler navbar-toggler-right" type="button"
      data-toggle="collapse" data-target="#navbarSupportedContent">
      <span class="navbar-toggler-icon"></span>
    </button>
    <router-link to="/" class="navbar-brand">
      zeitgeist <span>creams</span>
    </router-link>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul v-if="loggedIn" class="navbar-nav mr-auto">
        <li class="nav-item" v-if="isAuthorized('creams-edit')">
          <router-link class="nav-link" to="/creams">Sorten</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/selections/1">
            Mannheim
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/selections/2">
            Limburgerhof
          </router-link>
        </li>
      </ul>
      <ul class="navbar-nav" v-if="user.username">
        <li class="nav-item">
          <a class="nav-link" href="#" @click.prevent="logout">
            Logout ({{ user.username }})
          </a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import auth from '../../services/auth'

export default {
  data () {
    return {
      user: {}
    }
  },

  computed: {
    loggedIn () {
      return this.user
    }
  },

  watch: {
    $route () {
      this.user = auth.current
    }
  },

  methods: {
    logout () {
      auth.logout()
      this.$router.replace('/login')
    },

    isAuthorized (action, restriction) {
      return auth.isAuthorized(action, restriction)
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/variables";

  .navbar-brand {
    color: $brand-primary;

    &:focus,
    &:hover {
      color: $brand-primary;
    }

    > span {
      font-size: $font-size-sm;
      color: $brand-secondary;
    }
  }
</style>



// WEBPACK FOOTER //
// navbar.vue?740767de